module.exports = __webpack_public_path__ + "static/media/west_africa_mototurismo_1.59b0ab0f.jpg";